export const mapInvoiceToSummary = (invoice) => {
  if (!invoice) return null;
  return {
    id: invoice.id,
    invoiceNumber: invoice.invoiceNumber,
    issueDate: invoice.issueDate,
    dueDate: invoice.dueDate,
    transactionStatus: invoice.transactionStatus,
    status: invoice.status,
    customerBusinessName: invoice.customerBusinessName,
    subtotal: invoice.subtotal,
    totalTax: invoice.totalTax,
    total: invoice.total,
    amountPaid: invoice.amountPaid,
  };
};
